exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--card__1ORjm{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;max-width:100%;margin-bottom:0;-webkit-box-sizing:border-box;box-sizing:border-box}.styles--card__1ORjm.block{padding:18px 20px;border-top-left-radius:0px;border-top-right-radius:0px}.styles--card__1ORjm+.styles--card__1ORjm{margin-top:10px}.styles--card__1ORjm .block:first-child{border-top-left-radius:0;border-top-right-radius:0}\n", ""]);

// exports
exports.locals = {
	"card": "styles--card__1ORjm"
};